// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2760%27 height=%2760%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cdefs%3E%3Cpattern id=%27grid%27 width=%2720%27 height=%2720%27 patternUnits=%27userSpaceOnUse%27%3E%3Cpath d=%27M 20 0 L 0 0 0 20%27 fill=%27none%27 stroke=%27%2300ffff%27 stroke-width=%270.2%27 opacity=%270.08%27/%3E%3C/pattern%3E%3C/defs%3E%3Crect width=%2760%27 height=%2760%27 fill=%27url%28%23grid%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header背景样式 - 支持GIF动图 + 优化移动显示 */
.header-background {
  background: 
    /* 轻微的前景遮罩，让图片更清晰 */
    linear-gradient(135deg, rgba(0, 20, 40, 0.2) 0%, rgba(0, 10, 30, 0.15) 50%, rgba(10, 0, 40, 0.2) 100%),
    /* 减少光效层的不透明度 */
    radial-gradient(ellipse at 20% 80%, rgba(0, 255, 255, 0.05) 0%, transparent 60%),
    radial-gradient(ellipse at 80% 20%, rgba(0, 150, 255, 0.03) 0%, transparent 60%);
  background-size: 
    cover,  /* 使用cover确保图片完整显示，优先保持比例 */
    400px 400px,
    500px 500px;
  background-position: 
    left center,  /* 默认就左对齐，确保左边内容优先显示 */
    0 0,
    100% 100%;
  background-repeat: no-repeat;
  background-attachment: fixed;
  position: relative;
  /* 减少模糊效果让图片更清晰 */
  backdrop-filter: blur(1px);
  /* 移除背景移动动画 */
  /* animation: backgroundShift 20s ease-in-out infinite alternate; */
  /* 确保GIF动图能正常播放 */
  image-rendering: auto;
  -webkit-image-rendering: auto;
}

.header-background::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}),
    linear-gradient(90deg, transparent 0%, rgba(0, 255, 255, 0.02) 50%, transparent 100%);
  background-size: 60px 60px, 100% 100%;
  opacity: 0.3;
  pointer-events: none;
  animation: gridMove 30s linear infinite;
}

.header-background::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 200%;
  height: 100%;
  background: linear-gradient(90deg, 
    transparent 0%, 
    transparent 45%, 
    rgba(0, 255, 255, 0.05) 50%, 
    transparent 55%, 
    transparent 100%
  );
  animation: scanLine 12s linear infinite;
  pointer-events: none;
  opacity: 0.4;
}

@keyframes backgroundShift {
  0% {
    background-position: 0 0, 0 0, 100% 100%, 50% 0, 0 0;
  }
  50% {
    background-position: 0 0, 50% 50%, 50% 50%, 0 100%, 0 0;
  }
  100% {
    background-position: 0 0, 100% 100%, 0 0, 100% 0, 0 0;
  }
}

@keyframes gridMove {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(20px, 20px);
  }
}

@keyframes scanLine {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

/* 移动设备优化 */
@media (max-width: 768px) {
  .header-background {
    /* 移动设备上移除 fixed 定位避免性能问题 */
    background-attachment: scroll;
    /* 优化背景尺寸，确保图片左侧内容完整显示 */
    background-size: 
      cover,  /* 主背景图片使用cover确保完整显示 */
      200px 200px,
      250px 250px;
    /* 背景定位：确保图片左边内容优先显示 */
    background-position: 
      left center,  /* 主背景图片左对齐居中 */
      0 0,
      100% 100%;
    /* 减少模糊效果提升性能 */
    backdrop-filter: none;
  }
  
  .header-background::before {
    /* 移动设备上减少网格动画的复杂度 */
    animation: none;
    opacity: 0.2;
  }
  
  .header-background::after {
    /* 移动设备上减少扫描线效果 */
    animation: none;
    opacity: 0.2;
  }
}

@media (max-width: 480px) {
  .header-background {
    /* 小屏幕设备进一步优化，确保图片左侧内容完整显示 */
    background-size: 
      auto 100%,  /* 高度100%，宽度自适应，保持比例 */
      150px 150px,
      200px 200px;
    /* 强制左对齐显示，确保图片左边内容可见 */
    background-position: 
      left center,  /* 主背景图片严格左对齐 */
      0 0,
      100% 100%;
    /* 如果图片宽度不够，添加重复模式 */
    background-repeat: 
      no-repeat,
      no-repeat,
      no-repeat;
  }
  
  .header-background::before,
  .header-background::after {
    /* 小屏幕完全移除特效以提升性能 */
    display: none;
  }
}

/* 让Header文字更突出 */
.header-background .header-title {
  text-shadow: 
    3px 3px 6px rgba(0, 0, 0, 0.9),
    0 0 12px rgba(0, 0, 0, 0.8),
    0 0 20px rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
  color: #fff !important; /* 强制白色 */
}

.header-background .header-title:hover {
  text-shadow: 
    3px 3px 8px rgba(0, 0, 0, 0.9),
    0 0 15px rgba(0, 0, 0, 0.8),
    0 0 25px rgba(255, 255, 255, 0.5);
  transform: scale(1.05);
  color: #fff !important; /* 悬停时保持白色 */
}

.header-background .header-logo {
  filter: 
    drop-shadow(3px 3px 6px rgba(0, 0, 0, 0.9))
    drop-shadow(0 0 12px rgba(0, 0, 0, 0.6))
    brightness(1.2)
    contrast(1.3);
  transition: all 0.3s ease;
}

.header-background .header-logo:hover {
  filter: 
    drop-shadow(4px 4px 8px rgba(0, 0, 0, 0.9))
    drop-shadow(0 0 16px rgba(0, 0, 0, 0.8))
    brightness(1.3)
    contrast(1.4);
  transform: scale(1.1) rotate(5deg);
}

/* Header在移动设备上的响应式优化 */
@media (max-width: 768px) {
  .header-background .header-title {
    font-size: 1rem;
    text-shadow: 
      2px 2px 4px rgba(0, 0, 0, 0.9),
      0 0 8px rgba(0, 0, 0, 0.7),
      0 0 12px rgba(255, 255, 255, 0.2);
    color: #fff !important;
  }
  
  .header-background .header-logo {
    height: 40px;
  }
}

@media (max-width: 480px) {
  .header-background .header-title {
    font-size: 0.9rem;
    letter-spacing: 0.5px;
    text-shadow: 
      2px 2px 4px rgba(0, 0, 0, 0.9),
      0 0 6px rgba(0, 0, 0, 0.7);
    color: #fff !important;
  }
  
  .header-background .header-logo {
    height: 36px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/headerBackground.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE;;;;;oFAKkF;EAClF;;;eAGa;EACb;;;aAGW;EACX,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,aAAa;EACb,mEAAmE;EACnE,iBAAiB;EACjB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;yFAEuF;EACvF,qCAAqC;EACrC,YAAY;EACZ,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;;GAMC;EACD,uCAAuC;EACvC,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE;IACE,oDAAoD;EACtD;EACA;IACE,uDAAuD;EACzD;EACA;IACE,qDAAqD;EACvD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;;AAEA,WAAW;AACX;EACE;IACE,2BAA2B;IAC3B,6BAA6B;IAC7B,wBAAwB;IACxB;;;iBAGa;IACb,sBAAsB;IACtB;;;eAGW;IACX,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;IACpB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B;;;iBAGa;IACb,uBAAuB;IACvB;;;eAGW;IACX,oBAAoB;IACpB;;;eAGW;EACb;;EAEA;;IAEE,mBAAmB;IACnB,aAAa;EACf;AACF;;AAEA,iBAAiB;AACjB;EACE;;;qCAGmC;EACnC,yBAAyB;EACzB,sBAAsB,EAAE,SAAS;AACnC;;AAEA;EACE;;;qCAGmC;EACnC,sBAAsB;EACtB,sBAAsB,EAAE,YAAY;AACtC;;AAEA;EACE;;;;iBAIe;EACf,yBAAyB;AAC3B;;AAEA;EACE;;;;iBAIe;EACf,kCAAkC;AACpC;;AAEA,uBAAuB;AACvB;EACE;IACE,eAAe;IACf;;;uCAGmC;IACnC,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,qBAAqB;IACrB;;gCAE4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["/* Header背景样式 - 支持GIF动图 + 优化移动显示 */\n.header-background {\n  background: \n    /* 轻微的前景遮罩，让图片更清晰 */\n    linear-gradient(135deg, rgba(0, 20, 40, 0.2) 0%, rgba(0, 10, 30, 0.15) 50%, rgba(10, 0, 40, 0.2) 100%),\n    /* 减少光效层的不透明度 */\n    radial-gradient(ellipse at 20% 80%, rgba(0, 255, 255, 0.05) 0%, transparent 60%),\n    radial-gradient(ellipse at 80% 20%, rgba(0, 150, 255, 0.03) 0%, transparent 60%);\n  background-size: \n    cover,  /* 使用cover确保图片完整显示，优先保持比例 */\n    400px 400px,\n    500px 500px;\n  background-position: \n    left center,  /* 默认就左对齐，确保左边内容优先显示 */\n    0 0,\n    100% 100%;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  position: relative;\n  /* 减少模糊效果让图片更清晰 */\n  backdrop-filter: blur(1px);\n  /* 移除背景移动动画 */\n  /* animation: backgroundShift 20s ease-in-out infinite alternate; */\n  /* 确保GIF动图能正常播放 */\n  image-rendering: auto;\n  -webkit-image-rendering: auto;\n}\n\n.header-background::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    url(\"data:image/svg+xml,%3Csvg width='60' height='60' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cpattern id='grid' width='20' height='20' patternUnits='userSpaceOnUse'%3E%3Cpath d='M 20 0 L 0 0 0 20' fill='none' stroke='%2300ffff' stroke-width='0.2' opacity='0.08'/%3E%3C/pattern%3E%3C/defs%3E%3Crect width='60' height='60' fill='url(%23grid)'/%3E%3C/svg%3E\"),\n    linear-gradient(90deg, transparent 0%, rgba(0, 255, 255, 0.02) 50%, transparent 100%);\n  background-size: 60px 60px, 100% 100%;\n  opacity: 0.3;\n  pointer-events: none;\n  animation: gridMove 30s linear infinite;\n}\n\n.header-background::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 200%;\n  height: 100%;\n  background: linear-gradient(90deg, \n    transparent 0%, \n    transparent 45%, \n    rgba(0, 255, 255, 0.05) 50%, \n    transparent 55%, \n    transparent 100%\n  );\n  animation: scanLine 12s linear infinite;\n  pointer-events: none;\n  opacity: 0.4;\n}\n\n@keyframes backgroundShift {\n  0% {\n    background-position: 0 0, 0 0, 100% 100%, 50% 0, 0 0;\n  }\n  50% {\n    background-position: 0 0, 50% 50%, 50% 50%, 0 100%, 0 0;\n  }\n  100% {\n    background-position: 0 0, 100% 100%, 0 0, 100% 0, 0 0;\n  }\n}\n\n@keyframes gridMove {\n  0% {\n    transform: translate(0, 0);\n  }\n  100% {\n    transform: translate(20px, 20px);\n  }\n}\n\n@keyframes scanLine {\n  0% {\n    left: -100%;\n  }\n  100% {\n    left: 100%;\n  }\n}\n\n/* 移动设备优化 */\n@media (max-width: 768px) {\n  .header-background {\n    /* 移动设备上移除 fixed 定位避免性能问题 */\n    background-attachment: scroll;\n    /* 优化背景尺寸，确保图片左侧内容完整显示 */\n    background-size: \n      cover,  /* 主背景图片使用cover确保完整显示 */\n      200px 200px,\n      250px 250px;\n    /* 背景定位：确保图片左边内容优先显示 */\n    background-position: \n      left center,  /* 主背景图片左对齐居中 */\n      0 0,\n      100% 100%;\n    /* 减少模糊效果提升性能 */\n    backdrop-filter: none;\n  }\n  \n  .header-background::before {\n    /* 移动设备上减少网格动画的复杂度 */\n    animation: none;\n    opacity: 0.2;\n  }\n  \n  .header-background::after {\n    /* 移动设备上减少扫描线效果 */\n    animation: none;\n    opacity: 0.2;\n  }\n}\n\n@media (max-width: 480px) {\n  .header-background {\n    /* 小屏幕设备进一步优化，确保图片左侧内容完整显示 */\n    background-size: \n      auto 100%,  /* 高度100%，宽度自适应，保持比例 */\n      150px 150px,\n      200px 200px;\n    /* 强制左对齐显示，确保图片左边内容可见 */\n    background-position: \n      left center,  /* 主背景图片严格左对齐 */\n      0 0,\n      100% 100%;\n    /* 如果图片宽度不够，添加重复模式 */\n    background-repeat: \n      no-repeat,\n      no-repeat,\n      no-repeat;\n  }\n  \n  .header-background::before,\n  .header-background::after {\n    /* 小屏幕完全移除特效以提升性能 */\n    display: none;\n  }\n}\n\n/* 让Header文字更突出 */\n.header-background .header-title {\n  text-shadow: \n    3px 3px 6px rgba(0, 0, 0, 0.9),\n    0 0 12px rgba(0, 0, 0, 0.8),\n    0 0 20px rgba(255, 255, 255, 0.3);\n  transition: all 0.3s ease;\n  color: #fff !important; /* 强制白色 */\n}\n\n.header-background .header-title:hover {\n  text-shadow: \n    3px 3px 8px rgba(0, 0, 0, 0.9),\n    0 0 15px rgba(0, 0, 0, 0.8),\n    0 0 25px rgba(255, 255, 255, 0.5);\n  transform: scale(1.05);\n  color: #fff !important; /* 悬停时保持白色 */\n}\n\n.header-background .header-logo {\n  filter: \n    drop-shadow(3px 3px 6px rgba(0, 0, 0, 0.9))\n    drop-shadow(0 0 12px rgba(0, 0, 0, 0.6))\n    brightness(1.2)\n    contrast(1.3);\n  transition: all 0.3s ease;\n}\n\n.header-background .header-logo:hover {\n  filter: \n    drop-shadow(4px 4px 8px rgba(0, 0, 0, 0.9))\n    drop-shadow(0 0 16px rgba(0, 0, 0, 0.8))\n    brightness(1.3)\n    contrast(1.4);\n  transform: scale(1.1) rotate(5deg);\n}\n\n/* Header在移动设备上的响应式优化 */\n@media (max-width: 768px) {\n  .header-background .header-title {\n    font-size: 1rem;\n    text-shadow: \n      2px 2px 4px rgba(0, 0, 0, 0.9),\n      0 0 8px rgba(0, 0, 0, 0.7),\n      0 0 12px rgba(255, 255, 255, 0.2);\n    color: #fff !important;\n  }\n  \n  .header-background .header-logo {\n    height: 40px;\n  }\n}\n\n@media (max-width: 480px) {\n  .header-background .header-title {\n    font-size: 0.9rem;\n    letter-spacing: 0.5px;\n    text-shadow: \n      2px 2px 4px rgba(0, 0, 0, 0.9),\n      0 0 6px rgba(0, 0, 0, 0.7);\n    color: #fff !important;\n  }\n  \n  .header-background .header-logo {\n    height: 36px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
